<template>
  <fragment v-if="isPodcaster()">
    <episode-edit />
  </fragment>
  <fragment v-else>
    <item-edit />
  </fragment>
</template>

<script>
import EpisodeEdit from "VueApp/Items/Podcaster/EpisodeEdit";
import ItemEdit from "VueApp/Items/Broadcaster/ItemEdit";

export default {
  components: {
    ItemEdit,
    EpisodeEdit,
  },
};
</script>
